import { io } from 'socket.io-client';
import { replayAll } from '../utils/socketUtils/replayableEmits';

const socket = io(process.env.REACT_APP_SOCKET, {
  autoConnect: false,
  transports: ['websocket'],
  withCredentials: true,
});

// Флаг, чтобы не дублировать первичные emit'ы, которые могли попасть в очередь socket.io.
let hasConnectedOnce = false;

// Добавление обработчика события 'connect'
socket.on('connect', () => {
  console.log('Socket connected.  🚀 ');
  // При реконнекте переэмитим только сохранённые стрим-старты.
  if (hasConnectedOnce) {
    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    replayAll(socket, pathname);
  }
  hasConnectedOnce = true;
});
socket.on('disconnect', () => {
  console.log('Socket disconnected.  🧹 ');
});


export default socket;
